import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PageLayout from '../components/layout/PageLayout';
import SEOHead from '../components/shared/SEOHead';

const NotFoundPage = () => (
  <PageLayout>
    <SEOHead title="Page not found | Kalobrate" description="The page you are looking for does not exist." />
    <section className="py-28 md:py-40">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="text-7xl font-heading font-bold text-golden block mb-4">404</span>
        <h1 className="text-2xl sm:text-3xl font-heading font-bold text-carbon mb-4 tracking-tight">Page not found</h1>
        <p className="text-base text-carbon/70 leading-relaxed mb-8">
          The page you are looking for may have been moved or no longer exists.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="bg-golden text-carbon px-7 py-3 font-semibold text-sm hover:bg-golden/90 transition-colors inline-flex items-center justify-center">
            <ArrowLeft className="mr-2 w-4 h-4" /> Back to homepage
          </Link>
          <Link to="/contact" className="border border-gray-200 text-carbon px-7 py-3 font-semibold text-sm hover:bg-gray-50 transition-colors inline-flex items-center justify-center">
            Contact Kalobrate
          </Link>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default NotFoundPage;
